
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/become-instructor",
      function () {
        return require("private-next-pages/become-instructor.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/become-instructor"])
      });
    }
  